import { render, staticRenderFns } from "./AddAgentView.vue?vue&type=template&id=2508b8fc&scoped=true"
import script from "./AddAgentView.vue?vue&type=script&lang=js"
export * from "./AddAgentView.vue?vue&type=script&lang=js"
import style0 from "./AddAgentView.vue?vue&type=style&index=0&id=2508b8fc&prod&scoped=true&lang=css"
import style1 from "./AddAgentView.vue?vue&type=style&index=1&id=2508b8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508b8fc",
  null
  
)

export default component.exports